export default "__VITE_ASSET__DgDv5cuy__"